import mixpanel from 'mixpanel-browser';

// @TODO(juan): extract this to a reusable function. For some reason it errors out if we do, need to investigate whats going on
export const trackMixpanelEvent = (eventName: string, properties = {}) => {
  return new Promise(resolve => {
    mixpanel.track(
      eventName,
      properties,
      {
        send_immediately: true,
      },
      () => {
        resolve(true);
      },
    );
  });
};